import { useCallback, useEffect, useState } from 'react';
import { useErrorHandling } from '../hooks/useErrorHandling';
import fetch from '@rd-web-markets/shared/dist/services/Fetcher';
import { request } from '@rd-web-markets/shared/dist/services/request';
import { buildService } from './service';
import serviceMethods from './service_methods';
const api = buildService('/companies/{id}/business_units', {
  only: ['all']
});
const businessUnitsService = {
  useFetchAll: _ref => {
    let {
      companyId,
      setLoading,
      fetchImmediately = true
    } = _ref;
    const [businessUnits, setBusinessUnits, fetchBusinessUnits, pages] = serviceMethods.useFetch({
      callback: useCallback(async () => await api.all(companyId), [companyId]),
      setLoading,
      fetchImmediately,
      paginationResourceField: 'business_units'
    });
    return [businessUnits, setBusinessUnits, fetchBusinessUnits, pages];
  },
  useFetchBusinessUnit(companyId, businessUnitId, setLoading) {
    const [businessUnit, setBusinessUnit] = useState(null);
    const fetchBusinessUnit = useErrorHandling(useCallback(async () => {
      setLoading && setLoading(true);
      const unit = await businessUnitsService.get(companyId, businessUnitId);
      setBusinessUnit(unit);
      setLoading && setLoading(false);
    }, [companyId, businessUnitId, setLoading]), useCallback(async () => {
      setLoading && setLoading(false);
    }, [setLoading]));
    useEffect(() => {
      fetchBusinessUnit();
    }, [fetchBusinessUnit]);
    return [businessUnit, setBusinessUnit];
  },
  useUpdateBusinessUnit(companyId, setBusinessUnit) {
    const updateBusinessUnit = useErrorHandling(useCallback(async unit => {
      const updatedUnit = await businessUnitsService.update(companyId, unit);
      setBusinessUnit(updatedUnit);
    }, [companyId, setBusinessUnit]));
    return updateBusinessUnit;
  },
  create(companyId, business_unit) {
    return fetch(`/api/companies/${companyId}/business_units`, {
      ...request.post,
      body: JSON.stringify({
        business_unit
      })
    });
  },
  get(companyId, business_unit_id) {
    return fetch(`/api/companies/${companyId}/business_units/${business_unit_id}`, {
      ...request.get
    });
  },
  delete(companyId, business_unit_id) {
    return fetch(`/api/companies/${companyId}/business_units/${business_unit_id}`, {
      ...request.delete
    });
  },
  update(companyId, business_unit) {
    return fetch(`/api/companies/${companyId}/business_units/${business_unit.id}`, {
      ...request.put,
      body: JSON.stringify({
        business_unit
      })
    });
  },
  all(companyId) {
    let queryString = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    const url = `/api/companies/${companyId}/business_units${queryString ? `?${queryString}` : ''}`;
    return fetch(url, {
      ...request.get
    });
  }
};
export default businessUnitsService;